<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <i-input prefix="ios-search" placeholder="输入企业名称查询" v-model="search.name" style="width: auto;margin-left: 1em" />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="企业类型" prop="companyType">
          <Select v-model="formValidate.companyType" clearable>
            <Option v-for="item in companyTypeEnum" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="企业名称：" prop="companyName">
          <i-input v-model="formValidate.companyName" placeholder="输入企业名称"></i-input>
        </FormItem>
        <FormItem label="联系人名称：" prop="contactName">
          <i-input v-model="formValidate.contactName" placeholder="输入联系人名称"></i-input>
        </FormItem>
        <FormItem label="联系电话：" prop="contactTel">
          <i-input v-model="formValidate.contactTel" placeholder="输入联系电话"></i-input>
        </FormItem>
        <FormItem label="营业执照编号：" prop="companyCode">
          <i-input v-model="formValidate.companyCode" placeholder="输入企业营业执照编号"></i-input>
        </FormItem>
        <FormItem label="经营许可证：" prop="permitImage">
          <div class="form_upload">
            <LoadImg :imgUrl="formValidate.permitImage" @close="imgLoadDel" @success="imgLoadSuccess($event)"></LoadImg>
          </div>
        </FormItem>
        <FormItem label="许可证截止于：" prop="dueDate">
          <DatePicker type="date" placeholder="选择许可证截止日期" v-model="formValidate.dueDate"></DatePicker>
        </FormItem>

        <FormItem label="企业备注信息：" prop="companyNotes">
          <i-input v-model="formValidate.companyNotes" type="textarea" :rows="2" placeholder="输入企业备注信息"></i-input>
        </FormItem>
      </Form>
      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import LoadImg from "../../../components/Load_img.vue";
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "序号",
            key: "index",
            width: 80,
            align: "center"
          },
          {
            title: "企业类型",
            key: "companyType",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.getCompanyType(params.row.companyType) 
                ),
              ]);
            },
          },
          {
            title: "企业名称",
            key: "companyName",
            align: "center"
          },
          {
            title: "联系人名称",
            key: "contactName",
            align: "center"
          },
          {
            title: "联系电话",
            key: "contactTel",
            align: "center"
          },
          {
            title: "企业营业执照编号",
            key: "companyCode",
            align: "center"
          },
          {
            title: "企业备注信息",
            key: "companyNotes",
            align: "center"
          },
          {
            title: "经营许可证照片",
            key: "permitImage",
            align: "center",
            render(h, params) {
              return h(
                "div",
                {
                  style: {
                    height: "50px",
                    overflow: "hidden"
                  }
                },
                [
                  h("vImage", {
                    props: {
                      imgUrl: params.row.permitImage
                    }
                  })
                ]
              );
            }
          },
          {
            title: "截止日期",
            key: "dueDate",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("span", {}, timeStamp(params.row.dueDate, "yyyy-MM-dd"))
              ]);
            }
          },

          {
            title: "操作",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          companyType: params.row.companyType, // 企业类型：1表示运输单位、2表示接收单位
                          companyName: params.row.companyName, // 企业名称
                          contactName: params.row.contactName, // 联系人名称
                          contactTel: params.row.contactTel, // 联系电话
                          companyCode: params.row.companyCode, // 企业营业执照编号
                          companyNotes: params.row.companyNotes, // 企业备注信息
                          permitImage: params.row.permitImage, // 经营许可证照片
                          dueDate: timeStamp(
                            params.row.dueDate,
                            "yyyy-MM-dd",true
                          ),// 许可证截止日期
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,
        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      companyTypeEnum: [{ id: 0, name: '请选择单位类型' }, { id: 1, name: '运输单位' }, { id: 2, name: '接收单位' }],
      // 查询
      search: {
        name: null // 设备名
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        companyType: "", // 企业类型：1表示运输单位、2表示接收单位
        companyName: "", // 企业名称
        contactName: "", // 联系人名称
        contactTel: "", // 联系电话
        companyCode: "", // 企业营业执照编号
        companyNotes: "", // 企业备注信息
        permitImage: "", // 经营许可证照片
        dueDate: "", // 许可证截止日期
      },
      // 验证
      ruleValidate: {
        //companyType: [{ required: true, message: "请选择", trigger: "change" }],
        companyName: [{ required: true, message: "不能为空", trigger: "blur" }],
        contactName: [{ required: true, message: "不能为空", trigger: "blur" }],
        contactTel: [{ required: true, message: "不能为空", trigger: "blur" }],
        companyCode: [{ required: true, message: "不能为空", trigger: "blur" }],
        dueDate: [{ required: true, type: "date", message: "不能为空" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
    };
  },
  components: {
    toolbar,
    LoadImg
  },
  created() {
    this.getData(); // 数据初始化
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        companyType: "", // 企业类型：1表示运输单位、2表示接收单位
        companyName: "", // 企业名称
        contactName: "", // 联系人名称
        contactTel: "", // 联系电话
        companyCode: "", // 企业营业执照编号
        companyNotes: "", // 企业备注信息
        permitImage: "", // 经营许可证照片
        dueDate: "", // 许可证截止日期
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getWasteCompanyList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          // 给list数组中的每个元素添加index索引字段
          res.data.list.forEach((item, index) => {
            item.index = index + 1;
          });
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Waste.getWasteCompanyDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Waste.postWasteCompanyAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Waste.postWasteCompanyEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    imgLoadDel() {
      this.formValidate.permitImage = null;
    },
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.permitImage = url;
    },
    getCompanyType(id) {
      return id == 1 ? "运输单位" : "接收单位";
    },
  }
};
</script>